module.exports = __webpack_public_path__ + "img/navbarTggl.59f86eed.svg";